/**
 * Extrait un message lisible depuis les corps d’erreur FastAPI / JSON variés.
 */
export function messageFromApiErrorBody(data: unknown): string | null {
  if (!data || typeof data !== 'object') return null
  const o = data as Record<string, unknown>

  if (typeof o.detail === 'string') return o.detail

  if (Array.isArray(o.detail)) {
    const parts = o.detail
      .map((item) => {
        if (item && typeof item === 'object' && 'msg' in item) {
          return String((item as { msg?: string }).msg ?? '')
        }
        return typeof item === 'string' ? item : ''
      })
      .filter(Boolean)
    if (parts.length) return parts.join('; ')
  }

  if (typeof o.error === 'string') return o.error
  if (typeof o.message === 'string') return o.message
  return null
}
